function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M230.917 402L446.763 277.381L446.763 259.979L15.0708 259.979L15.0708 277.381L230.917 402Z",
  fill: "#5E6FDB",
  stroke: "black",
  strokeWidth: 1.06001,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  width: 249.238,
  height: 249.238,
  transform: "matrix(-0.866025 -0.5 -0.866025 0.5 446.735 259.833)",
  fill: "#B0B8ED",
  stroke: "black",
  strokeWidth: 1.06001,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  width: 25.4381,
  height: 25.4381,
  transform: "matrix(-0.866025 -0.5 -0.866025 0.5 259.892 112.485)",
  fill: "#B0B8ED",
  stroke: "black",
  strokeWidth: 0.706671,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  width: 25.4381,
  height: 10.5202,
  transform: "matrix(-0.866025 0.5 2.20305e-08 1 259.892 112.392)",
  fill: "#5E6FDB",
  stroke: "black",
  strokeWidth: 0.706671,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  width: 25.4381,
  height: 10.5104,
  transform: "matrix(0.866025 0.5 -2.20305e-08 1 215.832 112.401)",
  fill: "#5E6FDB",
  stroke: "black",
  strokeWidth: 0.706671,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  width: 11.5232,
  height: 45.8075,
  transform: "matrix(-0.866025 0.5 2.20305e-08 1 247.842 67.9357)",
  fill: "#F0EBE6",
  stroke: "black",
  strokeWidth: 0.706671,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  width: 11.5232,
  height: 43.5959,
  transform: "matrix(0.866025 0.5 -2.20305e-08 1 227.884 70.1482)",
  fill: "#D6D2CD",
  stroke: "black",
  strokeWidth: 0.706671,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  width: 23.162,
  height: 23.162,
  transform: "matrix(-0.866025 -0.5 -0.866025 0.5 313.501 192.262)",
  fill: "#D6D2CD",
  stroke: "black",
  strokeWidth: 0.706671,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  width: 23.162,
  height: 23.162,
  transform: "matrix(-0.866025 0.5 2.20305e-08 1 313.501 192.262)",
  fill: "#F0EBE6",
  stroke: "black",
  strokeWidth: 0.706671,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  width: 23.162,
  height: 23.162,
  transform: "matrix(0.866025 0.5 -2.20305e-08 1 273.383 192.262)",
  fill: "#F0EBE6",
  stroke: "black",
  strokeWidth: 0.706671,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref12 = /*#__PURE__*/React.createElement("rect", {
  width: 13.0438,
  height: 184.437,
  transform: "matrix(-0.866025 0.5 2.20305e-08 1 304.739 7.5437)",
  fill: "#F0EBE6",
  stroke: "black",
  strokeWidth: 0.706671,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref13 = /*#__PURE__*/React.createElement("rect", {
  width: 13.0438,
  height: 170.907,
  transform: "matrix(0.866025 0.5 -2.20305e-08 1 282.146 21.0739)",
  fill: "#D6D2CD",
  stroke: "black",
  strokeWidth: 0.706671,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M152.852 97.3634C152.852 79.93 140.613 72.8636 125.515 81.5803C110.417 90.297 98.1782 111.496 98.1782 128.929L98.1782 211.066L152.852 179.5L152.852 97.3634Z",
  fill: "black",
  stroke: "black",
  strokeWidth: 0.706671,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M348.25 300.22C351.902 298.112 351.902 294.694 348.25 292.586L152.812 179.749L98.2892 211.228L293.728 324.065C297.379 326.173 303.299 326.173 306.951 324.065L348.25 300.22Z",
  fill: "black",
  stroke: "black",
  strokeWidth: 0.706671,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M306.756 301.452L279.33 283.701L98.4745 162.864L152.997 131.386L337.196 237.733L337.199 237.731L354.945 247.976C359.997 250.893 364.092 257.986 364.092 263.819C364.092 266.93 362.928 269.054 361.075 269.917L306.756 301.452Z",
  fill: "#EEEEEE",
  stroke: "black",
  strokeWidth: 0.706671,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M319.949 255.76L324.046 246.776L297.597 241.545L271.147 246.776L267.051 255.76L293.5 271.031L319.949 255.76Z",
  fill: "#D6D2CD"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M241.319 208.729L245.416 199.745L218.966 194.514L192.517 199.745L188.42 208.729L214.87 224L241.319 208.729Z",
  fill: "#D6D2CD"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M175.37 178.292L179.467 169.307L153.017 164.076L126.568 169.307L122.471 178.292L148.921 193.562L175.37 178.292Z",
  fill: "#D6D2CD"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M309.596 295.417C309.596 289.584 305.501 282.491 300.449 279.574L98.5245 162.993L98.5245 184.117L300.449 300.698C305.501 303.615 309.596 301.251 309.596 295.417Z",
  fill: "#D6D2CD",
  stroke: "black",
  strokeWidth: 0.706671,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M303.139 291.689C303.139 289.385 301.521 286.584 299.526 285.432L98.5236 169.383L98.5236 177.726L299.526 293.775C301.521 294.927 303.139 293.993 303.139 291.689Z",
  fill: "#D6D2CD",
  stroke: "black",
  strokeWidth: 0.706671,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M303.139 291.689C303.139 289.385 301.521 286.584 299.526 285.432L98.5236 169.383L98.5236 177.726L299.526 293.775C301.521 294.927 303.139 293.993 303.139 291.689Z",
  fill: "black",
  stroke: "black",
  strokeWidth: 0.706671,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref23 = /*#__PURE__*/React.createElement("circle", {
  r: 2.8402,
  transform: "matrix(-0.866025 -0.5 -2.20305e-08 1 299.143 289.471)",
  fill: "#D6D2CD",
  stroke: "black",
  strokeWidth: 0.706671,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref24 = /*#__PURE__*/React.createElement("circle", {
  r: 2.8402,
  transform: "matrix(-0.866025 -0.5 -2.20305e-08 1 205.059 235.152)",
  fill: "#D6D2CD",
  stroke: "black",
  strokeWidth: 0.706671,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref25 = /*#__PURE__*/React.createElement("circle", {
  r: 2.8402,
  transform: "matrix(-0.866025 -0.5 -2.20305e-08 1 158.018 207.993)",
  fill: "#D6D2CD",
  stroke: "black",
  strokeWidth: 0.706671,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref26 = /*#__PURE__*/React.createElement("circle", {
  r: 2.8402,
  transform: "matrix(-0.866025 -0.5 -2.20305e-08 1 189.379 226.099)",
  fill: "#D6D2CD",
  stroke: "black",
  strokeWidth: 0.706671,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref27 = /*#__PURE__*/React.createElement("circle", {
  r: 2.8402,
  transform: "matrix(-0.866025 -0.5 -2.20305e-08 1 236.42 253.258)",
  fill: "#D6D2CD",
  stroke: "black",
  strokeWidth: 0.706671,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref28 = /*#__PURE__*/React.createElement("circle", {
  r: 2.8402,
  transform: "matrix(-0.866025 -0.5 -2.20305e-08 1 267.782 271.365)",
  fill: "#D6D2CD",
  stroke: "black",
  strokeWidth: 0.706671,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref29 = /*#__PURE__*/React.createElement("circle", {
  r: 2.8402,
  transform: "matrix(-0.866025 -0.5 -2.20305e-08 1 173.698 217.046)",
  fill: "#D6D2CD",
  stroke: "black",
  strokeWidth: 0.706671,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref30 = /*#__PURE__*/React.createElement("circle", {
  r: 2.8402,
  transform: "matrix(-0.866025 -0.5 -2.20305e-08 1 126.657 189.886)",
  fill: "#D6D2CD",
  stroke: "black",
  strokeWidth: 0.706671,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M364.004 262.932L309.596 294.618",
  stroke: "black",
  strokeWidth: 0.706671
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M352.199 246.424L297.792 278.11",
  stroke: "black",
  strokeWidth: 0.706671
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M352.195 246.432L297.625 277.938",
  stroke: "black",
  strokeWidth: 0.706671
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M212.811 165.953L158.241 197.459",
  stroke: "black",
  strokeWidth: 0.706671
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M282.504 206.192L227.935 237.698",
  stroke: "black",
  strokeWidth: 0.706671
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M317.352 226.31L262.782 257.816",
  stroke: "black",
  strokeWidth: 0.706671
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M177.963 145.835L123.394 177.341",
  stroke: "black",
  strokeWidth: 0.706671
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M247.658 186.073L193.088 217.578",
  stroke: "black",
  strokeWidth: 0.706671
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M334.774 236.37L280.205 267.875",
  stroke: "black",
  strokeWidth: 0.706671
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M195.387 155.895L140.817 187.401",
  stroke: "black",
  strokeWidth: 0.706671
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M265.081 196.132L210.511 227.638",
  stroke: "black",
  strokeWidth: 0.706671
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "M299.928 216.252L245.358 247.758",
  stroke: "black",
  strokeWidth: 0.706671
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  d: "M160.54 135.776L105.97 167.281",
  stroke: "black",
  strokeWidth: 0.706671
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  d: "M230.233 176.013L175.664 207.519",
  stroke: "black",
  strokeWidth: 0.706671
});

var _ref45 = /*#__PURE__*/React.createElement("rect", {
  width: 30.5411,
  height: 30.5411,
  transform: "matrix(-0.866025 -0.5 -0.866025 0.5 324.152 216.428)",
  fill: "#FFDBC0",
  stroke: "black",
  strokeWidth: 0.706671,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref46 = /*#__PURE__*/React.createElement("rect", {
  width: 4.50496,
  height: 30.5411,
  transform: "matrix(-0.866025 -0.5 -0.866025 0.5 312.878 209.918)",
  fill: "white",
  stroke: "black",
  strokeWidth: 0.706671,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref47 = /*#__PURE__*/React.createElement("rect", {
  width: 30.5411,
  height: 30.5411,
  transform: "matrix(-0.866025 0.5 2.20305e-08 1 324.152 216.428)",
  fill: "#FFB681",
  stroke: "black",
  strokeWidth: 0.706671,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref48 = /*#__PURE__*/React.createElement("rect", {
  width: 30.5411,
  height: 30.5411,
  transform: "matrix(0.866025 0.5 -2.20305e-08 1 271.254 216.428)",
  fill: "#E0A173",
  stroke: "black",
  strokeWidth: 0.706671,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref49 = /*#__PURE__*/React.createElement("rect", {
  width: 4.71439,
  height: 10.3233,
  transform: "matrix(0.866025 0.5 -2.20305e-08 1 282.437 222.88)",
  fill: "white",
  stroke: "black",
  strokeWidth: 0.706671,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref50 = /*#__PURE__*/React.createElement("rect", {
  width: 30.5411,
  height: 30.5411,
  transform: "matrix(-0.866025 -0.5 -0.866025 0.5 245.336 169.113)",
  fill: "#FFDBC0",
  stroke: "black",
  strokeWidth: 0.706671,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref51 = /*#__PURE__*/React.createElement("rect", {
  width: 30.5411,
  height: 30.5411,
  transform: "matrix(-0.866025 0.5 2.20305e-08 1 245.336 169.113)",
  fill: "#FFB681",
  stroke: "black",
  strokeWidth: 0.706671,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref52 = /*#__PURE__*/React.createElement("rect", {
  width: 30.5411,
  height: 30.5411,
  transform: "matrix(0.866025 0.5 -2.20305e-08 1 192.438 169.113)",
  fill: "#E0A173",
  stroke: "black",
  strokeWidth: 0.706671,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref53 = /*#__PURE__*/React.createElement("rect", {
  width: 34.1061,
  height: 34.1061,
  transform: "matrix(-0.866025 -0.5 -0.866025 0.5 211.501 279.758)",
  fill: "#D6D2CD",
  stroke: "black",
  strokeWidth: 0.706671,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref54 = /*#__PURE__*/React.createElement("rect", {
  width: 23.162,
  height: 23.162,
  transform: "matrix(-0.866025 -0.5 -0.866025 0.5 202.023 256.686)",
  fill: "#D6D2CD",
  stroke: "black",
  strokeWidth: 0.706671,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref55 = /*#__PURE__*/React.createElement("rect", {
  width: 23.162,
  height: 23.162,
  transform: "matrix(-0.866025 0.5 2.20305e-08 1 202.023 256.686)",
  fill: "#F0EBE6",
  stroke: "black",
  strokeWidth: 0.706671,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref56 = /*#__PURE__*/React.createElement("rect", {
  width: 23.162,
  height: 23.162,
  transform: "matrix(0.866025 0.5 -2.20305e-08 1 161.905 256.686)",
  fill: "#F0EBE6",
  stroke: "black",
  strokeWidth: 0.706671,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref57 = /*#__PURE__*/React.createElement("rect", {
  width: 30.5411,
  height: 30.5411,
  transform: "matrix(-0.866025 -0.5 -0.866025 0.5 179.48 139.292)",
  fill: "#FFDBC0",
  stroke: "black",
  strokeWidth: 0.706671,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref58 = /*#__PURE__*/React.createElement("rect", {
  width: 30.5411,
  height: 30.5411,
  transform: "matrix(-0.866025 0.5 2.20305e-08 1 179.48 139.292)",
  fill: "#FFB681",
  stroke: "black",
  strokeWidth: 0.706671,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref59 = /*#__PURE__*/React.createElement("rect", {
  width: 30.5411,
  height: 30.5411,
  transform: "matrix(0.866025 0.5 -2.20305e-08 1 126.581 139.292)",
  fill: "#E0A173",
  stroke: "black",
  strokeWidth: 0.706671,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref60 = /*#__PURE__*/React.createElement("ellipse", {
  rx: 21.834,
  ry: 15.2661,
  transform: "matrix(-1 0 0 1 236.994 60.6616)",
  fill: "#B0B8ED",
  stroke: "black",
  strokeWidth: 0.706671,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref61 = /*#__PURE__*/React.createElement("rect", {
  width: 13.0438,
  height: 182.235,
  transform: "matrix(-0.866025 0.5 2.20305e-08 1 193.261 71.8481)",
  fill: "#F0EBE6",
  stroke: "black",
  strokeWidth: 0.706671,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref62 = /*#__PURE__*/React.createElement("rect", {
  width: 115.605,
  height: 13.3922,
  transform: "matrix(-0.866025 0.5 2.20305e-08 1 293.442 14.0123)",
  fill: "#F0EBE6",
  stroke: "black",
  strokeWidth: 0.706671,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref63 = /*#__PURE__*/React.createElement("rect", {
  width: 13.0438,
  height: 182.335,
  transform: "matrix(0.866025 0.5 -2.20305e-08 1 170.668 71.8147)",
  fill: "#F0EBE6",
  stroke: "black",
  strokeWidth: 0.706671,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref64 = /*#__PURE__*/React.createElement("rect", {
  width: 13.0018,
  height: 141.698,
  transform: "matrix(-0.866025 -0.5 -0.866025 0.5 304.679 7.50085)",
  fill: "#F0EBE6",
  stroke: "black",
  strokeWidth: 0.706671,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref65 = /*#__PURE__*/React.createElement("rect", {
  width: 12.9321,
  height: 6.53626,
  transform: "matrix(-0.866025 -0.5 -0.866025 0.5 181.965 234.895)",
  fill: "#F0EBE6",
  stroke: "black",
  strokeWidth: 0.706671,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref66 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M176.315 238.163L165.116 231.697V243.492L158.178 256.525L169.378 262.992L176.031 250.493L176.315 250.657L176.315 249.959L176.315 249.958L176.315 249.958L176.315 238.163Z",
  fill: "#F0EBE6"
});

var _ref67 = /*#__PURE__*/React.createElement("path", {
  d: "M165.116 231.697H164.762C164.762 231.571 164.83 231.454 164.939 231.391C165.048 231.328 165.183 231.328 165.292 231.391L165.116 231.697ZM176.315 238.163L176.492 237.857C176.601 237.92 176.669 238.037 176.669 238.163L176.315 238.163ZM165.116 243.492H165.469C165.469 243.55 165.455 243.607 165.428 243.658L165.116 243.492ZM158.178 256.525L158.001 256.831C157.837 256.736 157.777 256.528 157.866 256.359L158.178 256.525ZM169.378 262.992L169.69 263.158C169.645 263.242 169.567 263.305 169.475 263.331C169.383 263.358 169.284 263.345 169.201 263.298L169.378 262.992ZM176.031 250.493L175.719 250.327C175.764 250.242 175.842 250.18 175.934 250.153C176.026 250.127 176.125 250.139 176.208 250.187L176.031 250.493ZM176.315 250.657H176.669C176.669 250.783 176.601 250.9 176.492 250.963C176.383 251.026 176.248 251.026 176.139 250.963L176.315 250.657ZM176.315 249.959H175.962C175.962 249.901 175.976 249.844 176.003 249.793L176.315 249.959ZM176.315 249.958L176.495 249.654C176.658 249.75 176.716 249.957 176.627 250.124L176.315 249.958ZM176.315 249.958L176.136 250.263C176.028 250.199 175.962 250.083 175.962 249.958H176.315ZM165.292 231.391L176.492 237.857L176.139 238.469L164.939 232.003L165.292 231.391ZM164.762 243.492V231.697H165.469V243.492H164.762ZM157.866 256.359L164.804 243.326L165.428 243.658L158.49 256.692L157.866 256.359ZM169.201 263.298L158.001 256.831L158.355 256.22L169.554 262.686L169.201 263.298ZM176.343 250.659L169.69 263.158L169.066 262.826L175.719 250.327L176.343 250.659ZM176.139 250.963L175.854 250.799L176.208 250.187L176.492 250.351L176.139 250.963ZM176.669 249.959L176.669 250.657H175.962L175.962 249.959H176.669ZM176.627 250.124L176.627 250.124L176.003 249.793L176.003 249.793L176.627 250.124ZM176.495 249.654L176.495 249.654L176.136 250.263L176.136 250.263L176.495 249.654ZM176.669 238.163L176.669 249.958H175.962L175.962 238.163L176.669 238.163Z",
  fill: "black"
});

var _ref68 = /*#__PURE__*/React.createElement("path", {
  d: "M165.291 246.957L172.927 251.365L168.197 260.25L160.562 255.842L165.291 246.957Z",
  fill: "#B0B8ED",
  stroke: "black",
  strokeWidth: 0.846348,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref69 = /*#__PURE__*/React.createElement("path", {
  d: "M163.043 251.37L170.679 255.778L168.196 260.249L160.561 255.84L163.043 251.37Z",
  fill: "#B0B8ED",
  stroke: "black",
  strokeWidth: 0.846348,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref70 = /*#__PURE__*/React.createElement("path", {
  d: "M163.043 251.372L165.526 252.777L163.043 257.248L160.561 255.843L163.043 251.372Z",
  fill: "#B0B8ED",
  stroke: "black",
  strokeWidth: 0.846348,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref71 = /*#__PURE__*/React.createElement("rect", {
  width: 11.3299,
  height: 6.74612,
  transform: "matrix(0.866025 0.5 -2.20305e-08 1 165.809 234.607)",
  fill: "#F0EBE6",
  stroke: "black",
  strokeWidth: 0.706671,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref72 = /*#__PURE__*/React.createElement("rect", {
  width: 9.04105,
  height: 4.13489,
  transform: "matrix(0.866025 0.5 -2.20305e-08 1 166.801 236.494)",
  fill: "#FFB681",
  stroke: "black",
  strokeWidth: 0.706671,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref73 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M176.316 238.156L181.965 234.895V253.37L181.965 255.707L169.378 262.974L176.316 249.855L176.316 238.156Z",
  fill: "#F0EBE6"
});

var _ref74 = /*#__PURE__*/React.createElement("path", {
  d: "M181.965 234.895L181.788 234.589C181.897 234.526 182.032 234.526 182.142 234.589C182.251 234.652 182.318 234.768 182.318 234.895H181.965ZM176.316 238.156H175.962C175.962 238.03 176.03 237.913 176.139 237.85L176.316 238.156ZM181.965 253.37H182.318H181.965ZM181.965 255.707H182.318C182.318 255.833 182.251 255.95 182.142 256.013L181.965 255.707ZM169.378 262.974L169.554 263.28C169.418 263.359 169.246 263.338 169.133 263.228C169.019 263.119 168.992 262.948 169.065 262.809L169.378 262.974ZM176.316 249.855H176.669C176.669 249.912 176.655 249.969 176.628 250.02L176.316 249.855ZM182.142 235.201L176.492 238.462L176.139 237.85L181.788 234.589L182.142 235.201ZM181.612 253.37V234.895H182.318V253.37H181.612ZM182.318 253.37L182.318 255.707H181.612L181.612 253.37H182.318ZM182.142 256.013L169.554 263.28L169.201 262.668L181.788 255.401L182.142 256.013ZM169.065 262.809L176.003 249.69L176.628 250.02L169.69 263.139L169.065 262.809ZM176.669 238.156L176.669 249.855H175.962L175.962 238.156H176.669Z",
  fill: "black"
});

var SvgPackageFactory = function SvgPackageFactory(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 462,
    height: 403,
    viewBox: "0 0 462 403",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPackageFactory, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/package-factory.ec4f8e30.svg";
export { ForwardRef as ReactComponent };